import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import './assets/styles/App.css';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import { Provider } from 'react-redux';
import store from 'stores';
import LoadingFallback from 'components/common/Loading/LoadingFallback';
// import { RouterProvider } from 'react-router-dom';
// import router from 'routes';
import { AuthContextProvider } from 'stores/auth-context';
import App from 'App';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from 'stores/cartContext';
import { CartPOSProvider } from 'stores/cartPOSContext';
import { CartSessionProvider } from 'stores/cartSessionContext';
import { WarehouseProvider } from 'stores/warehouseContext';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<LoadingFallback />}>
        <BrowserRouter basename={`${process.env.REACT_APP_BASE_PATH}`}>
          {/* <RouterProvider router={router} > */}
          <AuthContextProvider>
            <WarehouseProvider>
              <CartPOSProvider>
                <CartSessionProvider>
                  <CartProvider>
                    <App />
                  </CartProvider>
                </CartSessionProvider>
              </CartPOSProvider>
            </WarehouseProvider>
          </AuthContextProvider>

          {/* </RouterProvider> */}
        </BrowserRouter>
      </Suspense>
    </Provider>
  </React.StrictMode>,
);
reportWebVitals();
